/**
 * AI 게이트웨이 싱글턴(결정 #7). 키 볼트(결정 #15)와 묶어 앱 전역에서 공유한다.
 * UI/액션은 core의 AiGateway 인터페이스로만 다룬다(결정 #10).
 *
 * 프록시 베이스 URL은 빌드 환경변수(VITE_PROXY_BASE_URL)로 주입한다. 미설정 시
 * proxy 전송을 선택한 프로필은 자체 proxyUrl이 필요하다(결정 #7).
 */
import { WebAiGateway } from "../platform/ai/index.js";
import { keyVault } from "../platform/vault/index.js";

const proxyBaseUrl = import.meta.env["VITE_PROXY_BASE_URL"] as string | undefined;

export const aiGateway = new WebAiGateway(
  keyVault,
  proxyBaseUrl ? { proxyBaseUrl } : {},
);
